import React from 'react';
import { QUIZ_CONSTANTS } from '../lib/constants';
import PopOver from './PopOver';
import PropTypes from 'prop-types';

const PopoverContainer = props => {
  const {
    feedbackSelectionType,
    closePopover,
    submitPopOver,
    feedbackNoTextError,
    undoNoTextError
  } = props;
  return (
    <React.Fragment>
      {feedbackSelectionType === QUIZ_CONSTANTS.feedback.yes && (
        <PopOver
          type={QUIZ_CONSTANTS.feedback.yes}
          closePopover={closePopover}
          submitPopOver={submitPopOver}
          feedbackNoTextError={feedbackNoTextError}
          undoNoTextError={undoNoTextError}
        />
      )}
      {feedbackSelectionType === QUIZ_CONSTANTS.feedback.no && (
        <PopOver
          type={QUIZ_CONSTANTS.feedback.no}
          closePopover={closePopover}
          submitPopOver={submitPopOver}
          feedbackNoTextError={feedbackNoTextError}
          undoNoTextError={undoNoTextError}
        />
      )}
    </React.Fragment>
  );
};

PopoverContainer.propTypes = {
  feedbackSelectionType: PropTypes.string,
  closePopover: PropTypes.func,
  submitPopOver: PropTypes.func,
  feedbackNoTextError: PropTypes.bool,
  undoNoTextError: PropTypes.func
};

export default PopoverContainer;
